export const ANIMATION = {
    DURATION: 10,
  };
  
  export const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  export const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  
  export const vehicleEquipments = [
    {
      name: "ac",
      text: "AC",
      iconStyles: { stroke: "initial", fill: "initial" },
    },
    {
      name: "automatic",
      text: "Automatic",
    
    },
    {
      name: "kitchen",
      text: "Kitchen",
    
    },
    {
      name: "tv",
      text: "TV",
    
    },
    {
      name: "bathroom",
      text: "Bathroom",
   
    },
  ];
  
  export const vehicleTypes = [
    { name: "panelTruck", text: "panelTruck" },
    { name: "fullyIntegrated", text: "Fully Integrated" },
    { name: "alcove", text: "Alcove" },
  ];